import Card from "components/molecules/Card";
import { useCurrentAnnualEnergyConsumptionCard } from "queries/Reports/Baseline/useCurrentAnnualEnergyConsumptionCard";
import { useMemo } from "react";

function CurrentAnnualEnergyConsumptionCard({ filtersetUid }: { filtersetUid: string }) {
    const { data, error, isLoading } = useCurrentAnnualEnergyConsumptionCard(filtersetUid);

    const cardData = useMemo(() => {
        if (!data) return undefined;

        const { totalEnergyConsumption, averageEnergyIntensity } = data;

        return {
            header: {
                value: totalEnergyConsumption,
                displayInfoKey: "energyConsumption",
            },
            sections: [
                [
                    {
                        value: averageEnergyIntensity,
                        displayInfoKey: "energyUseIntensity",
                    },
                ],
            ],
        };
    }, [data]);

    return (
        <Card
            data={cardData}
            loading={isLoading}
            error={error?.toString()}
            cardTitle="Current Annual Energy Consumption"
        />
    );
}

export default CurrentAnnualEnergyConsumptionCard;
